import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
export function ActionableItemLoader({
  loadingComponent: LoadingComponent,
  children
}) {
  if (LoadingComponent) {
    return /*#__PURE__*/_jsx(LoadingComponent, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(LoadingSpinner, {});
}